<template>
  <span v-html="value.newValue || 'campo vazio'" />
</template>

<script>
export default {
  name: 'HistoricalChangeInclusionValue',

  props: { value: { type: Object, default: () => ({}) } }
}
</script>
